import { ChevronDown } from './ChevronDown';
import { Crossmark } from './Crossmark';
import { PaperAirplane } from './PaperAirplane';
import { ArrowTopRightOnSquare } from './ArrowTopRightOnSquare';
import { Message } from './Message';
import { Home } from './Home';

export const IconComponents = {
  ChevronDown: ChevronDown,
  Crossmark: Crossmark,
  PaperAirplane: PaperAirplane,
  ArrowTopRightOnSquare: ArrowTopRightOnSquare,
  Message: Message,
  Home: Home,
} as const;
